"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVERTED_STATEMENT_TYPE_MAP = exports.STATEMENT_TYPE_MAP = exports.Scripter = void 0;
// @deprecated
var core_1 = require("@storyplay/core");
Object.defineProperty(exports, "Scripter", { enumerable: true, get: function () { return core_1.Scripter; } });
Object.defineProperty(exports, "STATEMENT_TYPE_MAP", { enumerable: true, get: function () { return core_1.STATEMENT_TYPE_MAP; } });
Object.defineProperty(exports, "INVERTED_STATEMENT_TYPE_MAP", { enumerable: true, get: function () { return core_1.INVERTED_STATEMENT_TYPE_MAP; } });
